/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 31 2024
 **/

import { css } from "@emotion/react";

export const ButtonContainerStyle = css`
	position: relative;
	display: flex;
	gap: 4px;
	align-items: center;
`;

export const SplitterStyle = css`
	width: 1px;
	height: clamp(20px, 4vw, 30px);
	background-color: #fff;
	margin: auto 0.3rem;
`;
